module.exports = __webpack_public_path__ + "img/providerEN.26aabd03.png";